import {
  createSystem,
  defaultBaseConfig,
  defineConfig,
} from '@chakra-ui/react';

import { animationStyles } from './animation-styles';
import { breakpoints } from './breakpoints';
import { globalCss } from './global-css';
import { keyframes } from './keyframes';
import { layerStyles } from './layer-styles';
import { recipes } from './recipes';
import { semanticTokens } from './semantic-tokens';
import { slotRecipes } from './slot-recipes';
import { textStyles } from './text-styles';
import { tokens } from './tokens';

const themeConfig = defineConfig({
  preflight: true,
  cssVarsPrefix: 'chakra',
  cssVarsRoot: ':where(:root, :host)',
  globalCss,
  theme: {
    breakpoints,
    keyframes,
    tokens,
    semanticTokens,
    recipes,
    slotRecipes,
    textStyles,
    layerStyles,
    animationStyles,
  },
});

/**
 * We're running a fully ejected theme, so that we have full available locally.
 *
 * @see https://chakra-ui.com/guides/theming-upgrading-detached-theme
 *
 * ## Updating the theme when Chakra is updated
 *
 * ```sh
 * # eg after:
 * npm i @chakra-ui/react@latest @emotion/react@latest
 *
 * # overwrite our existing theme
 * npx @chakra-ui/cli eject -o src/theme
 *
 * # normalise differences
 * npm run lint:fix
 *
 * # manually review the changes, reverting changes we want to keep
 * ```
 */
export const system = createSystem(defaultBaseConfig, themeConfig);
